"use client";

import Link from 'next/link'

import { Container } from '@/components/common/Container'
import { FadeIn } from '@/components/FadeIn'
import { Logo } from '@/components/Logo'
import {useLanguage} from "@/context/LanguageContext";
import {Offices} from "@/components/Offices";

const texts = {
  en: {
    contactUs: 'Contact me',
  },
  it: {
    contactUs: 'Contattami',
  },
};
function useLanguageTexts() {
    const { language } = useLanguage();
    return texts[language as keyof typeof texts] || texts['en'];
}

const navigation = (texts: { contactUs: string }) => [
  {
    title: 'Link',
    links: [
      { title: texts.contactUs, href: '/contact' },
    ],
  },
];

function Navigation() {
  return (
    <nav>
      <ul role="list" className="grid grid-cols-2 gap-8 sm:grid-cols-3">
        {navigation(useLanguageTexts()).map((section, sectionIndex) => (
          <li key={sectionIndex}>
            <div className="font-display text-sm font-semibold tracking-wider text-neutral-950">
              {section.title}
            </div>
            <ul role="list" className="mt-4 text-sm text-neutral-700">
              {section.links.map((link, linkIndex) => (
                <li key={linkIndex} className="mt-4">
                  <Link
                    href={link.href}
                    className="transition hover:text-neutral-950"
                  >
                    {link.title}
                  </Link>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </nav>
  )
}

export function Footer() {
  return (
    <Container as="footer" className="mt-24 w-full sm:mt-32 lg:mt-40">
      <FadeIn>
        <div className="grid grid-cols-1 lg:grid-cols-2">
        </div>
        <div className="mt-24 mb-20 flex flex-wrap items-end justify-between gap-x-6 gap-y-4 border-t border-neutral-950/10 pt-12">
          <Link href="/" aria-label="Home">
            <Logo className="h-8" fillOnHover />
          </Link>
          <Navigation />
          <Offices  className="mt-6 grid grid-cols-1 gap-8 sm:grid-cols-2" />
        </div>
        <div className="mb-10 pb-10">
          <p className="text-sm text-neutral-700 text-center">
            © Cris Aguilar Espinoza {new Date().getFullYear()}
          </p>
        </div>
      </FadeIn>
    </Container>
  )
}
